// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditUserForm-commonHeaderAdmin-W_4gz {
	position: fixed !important;
}

.EditUserForm-adminLayout-nZSWU {
	padding-top: 64px !important;
}

.EditUserForm-box-nuXEs h2 {
	font-size: 21px;
	font-weight: 600;
}

.EditUserForm-exportLink-xD2Mo {
	margin-bottom: -29px;
}

.EditUserForm-blockCenter-YEY9L {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.EditUserForm-panelHeader-liGIN {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.EditUserForm-currencyselect-aTRpP {
	width: 100%;
	margin-right: 0px;
}

.EditUserForm-panelHeader-liGIN {
	overflow: hidden;
	position: relative;
}

.EditUserForm-mar0-mcNP8 {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.EditUserForm-blockCenter-YEY9L {
		padding: 0px;
	}

	.EditUserForm-panelHeader-liGIN {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.EditUserForm-sideAdminPageWrapper-B_j5P {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.EditUserForm-panelHeader-liGIN {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.EditUserForm-table-X1u61 {
	display: table;
}

.EditUserForm-tableRow-lXxKA {
	display: table-row;
}

.EditUserForm-tableCell-dyCda {
	display: table-cell;
	float: none;
}

.EditUserForm-formGroup-NDCg_ {
	margin-bottom: 6px;
}

.EditUserForm-select-SAVbl {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.EditUserForm-noMargin-nzqfa {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.EditUserForm-exportLink-xD2Mo {
	padding-top: 10px;
	padding-right: 10px;
}

.EditUserForm-labelTextNew-eLEhk {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditUserForm-displayInline-EF2Zo {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.EditUserForm-btnUPdate-xIrXS {
	display: inline-block;
}

.EditUserForm-btnModalDelete-oP10i {
	display: inline-block;
	margin-left: 15px;
}

.EditUserForm-radioBtn-GkrRM {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.EditUserForm-backgroundImg-bSnb9 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.EditUserForm-btnUPdate-xIrXS {
		display: block;
		margin-bottom: 12px;
	}

	.EditUserForm-btnModalDelete-oP10i {
		display: block;
		margin-left: 0px;
	}

	.EditUserForm-btnWidth-jHR4u {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.EditUserForm-bannerImageBg-zuCvh {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.EditUserForm-bannerDelete-Yx1qw {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.EditUserForm-modalRoot-i5d6Z {
	padding: 32px;
}

.EditUserForm-modalBorderBottom-cPJGu {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.EditUserForm-logInModalBody-agGrT {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.EditUserForm-exportSection-T5b8w {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.EditUserForm-exportSectionGridSub-jQEOJ {
	grid-template-columns: 50% 49% !important;
}

.EditUserForm-exportText-b1JY6 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.EditUserForm-exportLinkImg-tKOsG {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.EditUserForm-vtrMiddle-adn0v {
	vertical-align: middle;
}

.EditUserForm-exportImg-w9AeA {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditUserForm-profileViewlabel-Rg2he {
	display: inline-block;
	width: 38%
}

.EditUserForm-profileViewMainContent-VuLIe {
	display: inline-block;
	width: 62%;
}

.EditUserForm-profileViewMain-ri9jr {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.EditUserForm-profileViewInner-kRPXU {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.EditUserForm-profileImageSection-GusOy {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.EditUserForm-lastviewInner-nl0B9 {
	padding: 10px;
}

.EditUserForm-whyHostHoriLine-XmRCr {
	margin: 30px 0;
}

.EditUserForm-tableGrid-SiaxA {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.EditUserForm-headingContent-Tk5Ru {
	font-size: 18px;
	font-weight: 500;
}

.EditUserForm-refundTextColor-H_c0H {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.EditUserForm-dividerLine-k1Wy_ {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.EditUserForm-smallContent-nKjHQ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.EditUserForm-sideAdminPageWrapper-B_j5P {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.EditUserForm-sideAdminPageWrapper-B_j5P {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.EditUserForm-exportSection-T5b8w {
		grid-template-columns: 100%;
	}

	.EditUserForm-exportSectionGridSub-jQEOJ {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.EditUserForm-profileViewlabel-Rg2he {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditUserForm-profileViewMainContent-VuLIe {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.EditUserForm-ChangeToUpperCase-oFbYM {
	text-transform: uppercase
}

.EditUserForm-noBorder-iItKD {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.EditUserForm-siteAdminHeading-AvUvY {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditUserForm-siteAdminSubHeading-SXXIQ {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditUserForm-adminFormDivider-HZk25 {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.EditUserForm-errorMessage-h0gJu {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.EditUserForm-panelHeader-liGIN {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.EditUserForm-formGroup-NDCg_ {
  margin-bottom: 6px;
}

.EditUserForm-select-SAVbl {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.EditUserForm-labelText-lERfR {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `EditUserForm-commonHeaderAdmin-W_4gz`,
	"adminLayout": `EditUserForm-adminLayout-nZSWU`,
	"box": `EditUserForm-box-nuXEs`,
	"exportLink": `EditUserForm-exportLink-xD2Mo`,
	"blockCenter": `EditUserForm-blockCenter-YEY9L`,
	"panelHeader": `EditUserForm-panelHeader-liGIN`,
	"currencyselect": `EditUserForm-currencyselect-aTRpP`,
	"mar0": `EditUserForm-mar0-mcNP8`,
	"sideAdminPageWrapper": `EditUserForm-sideAdminPageWrapper-B_j5P`,
	"table": `EditUserForm-table-X1u61`,
	"tableRow": `EditUserForm-tableRow-lXxKA`,
	"tableCell": `EditUserForm-tableCell-dyCda`,
	"formGroup": `EditUserForm-formGroup-NDCg_`,
	"select": `EditUserForm-select-SAVbl`,
	"noMargin": `EditUserForm-noMargin-nzqfa`,
	"labelTextNew": `EditUserForm-labelTextNew-eLEhk`,
	"displayInline": `EditUserForm-displayInline-EF2Zo`,
	"btnUPdate": `EditUserForm-btnUPdate-xIrXS`,
	"btnModalDelete": `EditUserForm-btnModalDelete-oP10i`,
	"radioBtn": `EditUserForm-radioBtn-GkrRM`,
	"backgroundImg": `EditUserForm-backgroundImg-bSnb9`,
	"btnWidth": `EditUserForm-btnWidth-jHR4u`,
	"bannerImageBg": `EditUserForm-bannerImageBg-zuCvh`,
	"bannerDelete": `EditUserForm-bannerDelete-Yx1qw`,
	"modalRoot": `EditUserForm-modalRoot-i5d6Z`,
	"modalBorderBottom": `EditUserForm-modalBorderBottom-cPJGu`,
	"logInModalBody": `EditUserForm-logInModalBody-agGrT`,
	"exportSection": `EditUserForm-exportSection-T5b8w`,
	"exportSectionGridSub": `EditUserForm-exportSectionGridSub-jQEOJ`,
	"exportText": `EditUserForm-exportText-b1JY6`,
	"exportLinkImg": `EditUserForm-exportLinkImg-tKOsG`,
	"vtrMiddle": `EditUserForm-vtrMiddle-adn0v`,
	"exportImg": `EditUserForm-exportImg-w9AeA`,
	"profileViewlabel": `EditUserForm-profileViewlabel-Rg2he`,
	"profileViewMainContent": `EditUserForm-profileViewMainContent-VuLIe`,
	"profileViewMain": `EditUserForm-profileViewMain-ri9jr`,
	"profileViewInner": `EditUserForm-profileViewInner-kRPXU`,
	"profileImageSection": `EditUserForm-profileImageSection-GusOy`,
	"lastviewInner": `EditUserForm-lastviewInner-nl0B9`,
	"whyHostHoriLine": `EditUserForm-whyHostHoriLine-XmRCr`,
	"tableGrid": `EditUserForm-tableGrid-SiaxA`,
	"headingContent": `EditUserForm-headingContent-Tk5Ru`,
	"refundTextColor": `EditUserForm-refundTextColor-H_c0H`,
	"dividerLine": `EditUserForm-dividerLine-k1Wy_`,
	"smallContent": `EditUserForm-smallContent-nKjHQ`,
	"ChangeToUpperCase": `EditUserForm-ChangeToUpperCase-oFbYM`,
	"noBorder": `EditUserForm-noBorder-iItKD`,
	"siteAdminHeading": `EditUserForm-siteAdminHeading-AvUvY`,
	"siteAdminSubHeading": `EditUserForm-siteAdminSubHeading-SXXIQ`,
	"adminFormDivider": `EditUserForm-adminFormDivider-HZk25`,
	"errorMessage": `EditUserForm-errorMessage-h0gJu`,
	"labelText": `EditUserForm-labelText-lERfR`
};
module.exports = ___CSS_LOADER_EXPORT___;
